import { render, staticRenderFns } from "./modal-confirm-beauty-profile.vue?vue&type=template&id=48378572&scoped=true"
import script from "./modal-confirm-beauty-profile.vue?vue&type=script&lang=js"
export * from "./modal-confirm-beauty-profile.vue?vue&type=script&lang=js"
import style0 from "./modal-confirm-beauty-profile.vue?vue&type=style&index=0&id=48378572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48378572",
  null
  
)

export default component.exports